import { render, staticRenderFns } from "./ZarinPalTransaction.vue?vue&type=template&id=368ed97a&scoped=true&"
import script from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"
export * from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368ed97a",
  null
  
)

export default component.exports